// extracted by mini-css-extract-plugin
module.exports = {"sign__iframe":"Sign_sign__iframe__je8BP","sign__wrapper":"Sign_sign__wrapper__5Yl_z","productListTwo":"Sign_productListTwo__LexXL","productElement":"Sign_productElement__vP0Yv"};